import React from 'react';

import pluralize from 'pluralize';
import { useTranslation } from 'react-i18next';
import voca from 'voca';

import PersonalInfo from 'components/application/PersonalInfo';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { displayCurrencyString } from 'components/helpers/currency';
import { formatDuration } from 'components/helpers/dates';
import { resourceShape } from 'components/helpers/serialisableResources';

export default function BookingSidePanelCourseTab({ course }) {
  const currentActor = useCurrentActor();

  const { t: i18nTCommon } = useTranslation('common');

  const {
    costEstimate,
    expires,
    learningMethod,
    provider,
    renewalFrequency,
    renewalInterval,
    timeAmount,
    timeInterval,
  } = course.attributes;

  return (
    <div className='popup__body-content popup__body-content--border-top tw-border-grey-100'>
      <PersonalInfo
        label={i18nTCommon('courses.renewalFrequency')}
        text={
          expires ?
            voca.isBlank(renewalFrequency) ?
              ''
            : formatDuration({
                durationParts: {
                  [pluralize(renewalInterval)]: renewalFrequency,
                },
              })

          : i18nTCommon('shared.doesNotExpire')
        }
      />
      <PersonalInfo
        label={i18nTCommon('shared.method')}
        text={
          learningMethod &&
          i18nTCommon(
            `courses.learningMethods.${voca.camelCase(learningMethod)}`,
          )
        }
      />
      <PersonalInfo
        label={i18nTCommon('courses.provider')}
        text={provider ? String(provider) : ''}
      />
      <PersonalInfo
        label={i18nTCommon('courses.costEstimate')}
        text={
          costEstimate ?
            displayCurrencyString({
              string: String(costEstimate),
              currencyCode: currentActor.division.attributes.currencyCode,
            })
          : ''
        }
      />
      <PersonalInfo
        label={i18nTCommon('courses.timeEstimate')}
        text={
          voca.isBlank(timeAmount) ? '' : (
            formatDuration({
              durationParts: { [pluralize(timeInterval)]: timeAmount },
            })
          )
        }
      />
    </div>
  );
}

BookingSidePanelCourseTab.propTypes = {
  course: resourceShape('course'),
};
